export enum RoomSizeType {
  MINI = 2000,
  SMALL = 4000,
  MEDIUM = 8000,
  LARGE = 12000,
  EXTRA_LARGE = 16000,
  JUMBO = 20000,
}

export interface RoomSizeInfo {
  capacity: string;
  size: string;
  label?: string;
}

// returns minimum zoom level for the room size, 0.8 for MINI, 0.4 for JUMBO
export function mapRoomSizeToScale(size: RoomSizeType): number {
  const originalMin = RoomSizeType.MINI;
  const originalMax = RoomSizeType.JUMBO;
  const targetMin = 0.8;
  const targetMax = 0.4;
  const value = targetMin + ((size - originalMin) / (originalMax - originalMin)) * (targetMax - targetMin);
  // Round to two decimal places
  return Math.round(value * 100) / 100;
}
